import { useQuery } from 'react-query';
import { Field } from '../types/types';
import LandscanService from './landscanService';

export const useGetAllFields = () => {
  return useQuery<Field[]>(
    'all-fields', LandscanService.allFields
  );
}

